export const data = () => ({
  isDebug: true,
  loading: false,
  suggestionID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
